module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-150.9feb0a99.png";